/**
 *
 * @returns
 *
 * Loading Cinical Info
 */
import { useEffect, useState } from 'react';

import { useTranslation,Button } from 'soxo-bootstrap-core'

import { Modal, Typography } from 'antd';
import ClinicalInformation from '../../../emr/components/clinical-information/clinical-information';


const { Title } = Typography;

export function ClinicalInfoView(props) {

    const { t, i18n } = useTranslation(); // To Translate to another language

    let [visible, setVisible] = useState(false);


    /**
     * Get call
     */

    useEffect(() => {
    }, []);





    return (
        <div className="clinical-info-view">

            <div className='paga-actions'>

                <Button
                    type='secondary'
                    size={'small'}
                    onClick={() => {
                        setVisible(true);
                    }}
                >
                    {t('View Clinical Information')}
                </Button>
            </div>

            <Modal
                destroyOnClose={true}
                visible={visible}
                footer={null}
                onCancel={() => {
                    setVisible(false);
                }}
                width={'80%'}
                maskClosable={false}
            >
                <div>

                    <ClinicalInformation mode={'opreg'} visit_id={props.visit_id} enableModel={true} />


                </div>
            </Modal>
        </div>
    );
}
